import React from 'react';
import OutcomeIsland from './OutcomeIsland';
import WorkflowRoutingIsland from './WorkflowRoutingIsland';
import { selectWorkflowType } from '../../../store/redux/selectors';
import { useAppSelector } from '~/store/reduxHooks';


function Island() {
  const workflowType = useAppSelector(selectWorkflowType);

  if (workflowType === 'router') {
    return <WorkflowRoutingIsland data-dd-privacy="allow" />;
  }
  return <OutcomeIsland data-dd-privacy="allow" />;
}

export default React.memo(Island);
